import * as React from 'react';

import { EStarRating, getTermsValue } from '../../../../../JsonQuery';
import { StarRating } from '../../../components/filters/StarRating';
import { TAvailableModifierActions } from '../../../types/modifier';
import { getStarRatingLabel } from '../../../utils/getStarRatingLabel';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const StarRatingContainer: React.FC = () => {
  const { jsonQuery, onChange, onApply } = useFiltersContext();
  const starRating = getTermsValue('star_rating')(jsonQuery);
  const action: TAvailableModifierActions = 'setStarRating';
  const label = getStarRatingLabel(starRating) || 'Количество звёзд';

  const handleChange = React.useCallback(
    (starRating: EStarRating[] | null) => {
      onChange({ action, arguments: [starRating] });
      onApply();
    },
    [onChange],
  );

  return <StarRating label={label} value={starRating} onChange={handleChange} />;
};
